import {
    DEFAULT_PLAYTIME_LIMIT,
    PLAYTIME_TARIFF_RESTRICTION_APPLIES_TO_USER_TYPES,
    RESTRICTED_ADMIN_ROUTES,
    TARIFF_IDS_WITH_PLAY_TIME_LIMIT,
} from '@/config/tariff_constants';

export const extractTariffsFromResponse = (payload) => {
    if (payload && Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.tariffs)) return payload.tariffs;
    return [];
}

export function checkUserRouteAccess(user, routeName) {
    if (!user) {
        return {
            hasLimitTariff: false,
            noPlaytimeLeft: false,
            adminCantAccess: false,
        };
    }
    if (user.isSuperadmin || user.isManagerOrSupport) {
        return {
            hasLimitTariff: false,
            noPlaytimeLeft: false,
            adminCantAccess: false,
        };
    }
    const schoolTariffId = user.schools?.[0]?.tariffId;
    const userType = user.type;
    const hasLimitTariff =
        PLAYTIME_TARIFF_RESTRICTION_APPLIES_TO_USER_TYPES.includes(userType) &&
        TARIFF_IDS_WITH_PLAY_TIME_LIMIT.includes(schoolTariffId);

    const userPlayTime = getNormalizedPlaytime(user);
    const noPlaytimeLeft = PLAYTIME_TARIFF_RESTRICTION_APPLIES_TO_USER_TYPES.includes(userType) && userPlayTime <= 0;

    const adminCantAccess = userType === 'admin' && RESTRICTED_ADMIN_ROUTES.includes(routeName);

    return { hasLimitTariff, noPlaytimeLeft, adminCantAccess };
}

export function isFreeTariffTeacher(user) {
    if (!user || user.type !== 'teacher') return false;
    const schoolTariffId = user.schools?.[0]?.tariffId;
    return TARIFF_IDS_WITH_PLAY_TIME_LIMIT.includes(schoolTariffId);
}

export const getNormalizedPlaytime = (user) => {
    if (!user?.tariffSnapshot) return DEFAULT_PLAYTIME_LIMIT;

    const raw = Number(user.tariffSnapshot.playtime ?? 0);
    if (!Number.isFinite(raw)) return 0;
    return Math.max(raw, 0);
}